import type { Nullable } from "@core/domain/types/nullable.type";
import { CCAAEnumDto } from "@entity/data/dto/ccaa-enum.dto";
import { Type } from "class-transformer";
import {
    IsArray,
    IsBoolean,
    IsDateString,
    IsEnum,
    IsNotEmpty,
    IsNumber,
    IsOptional,
    IsString,
} from "class-validator";
import { DietTypeEnumDto } from "./diet-type.dto";
import { ExpenseSubTypeEnumDto } from "./expense-sub-type.dto";
import { ExpenseTypeEnumDto } from "./expense-type.dto";
import { ProjectExpenseInvoiceLineDto } from "./invoice-line.dto";
import { ProjectExpensePaymentInstallmentDto } from "./payment-installment.dto";
import { TransportTypeEnumDto } from "./transport-type.dto";

export class TravelDto {
    @IsNumber()
    @IsNotEmpty()
    id!: number;

    @IsDateString()
    @IsNotEmpty()
    created!: string;

    @IsDateString()
    @IsNotEmpty()
    modified!: string;

    @IsBoolean()
    @IsNotEmpty()
    is_active!: boolean;

    @IsEnum(ExpenseTypeEnumDto)
    @IsNotEmpty()
    type_expense!: ExpenseTypeEnumDto;

    @IsEnum(ExpenseSubTypeEnumDto)
    @IsOptional()
    subtype_expense!: ExpenseSubTypeEnumDto;

    @IsString()
    @IsOptional()
    full_name!: Nullable<string>;

    @IsString()
    @IsOptional()
    identification_document!: Nullable<string>;

    @IsString()
    @IsOptional()
    address!: Nullable<string>;

    @IsString()
    @IsOptional()
    position_function!: Nullable<string>;

    @IsString()
    @IsOptional()
    travel_destination!: Nullable<string>;

    @IsDateString()
    @IsOptional()
    date_departure!: Nullable<string>;

    @IsDateString()
    @IsOptional()
    date_return!: Nullable<string>;

    @IsEnum(TransportTypeEnumDto)
    @IsOptional()
    transportation_method!: TransportTypeEnumDto;

    @IsString()
    @IsOptional()
    other_transport!: Nullable<string>;

    @IsString()
    // In case is not a personal vehicle
    @IsOptional()
    amount!: Nullable<string>;

    @IsString()
    // In case it is a personal vehicle
    @IsOptional()
    kilometers!: Nullable<string>;

    @IsString()
    @IsOptional()
    // In case it is a personal vehicle
    cost_per_kilometer!: Nullable<string>;

    // Campos específicos para ACCOMMODATION_MEALS
    @IsString()
    @IsOptional()
    position!: Nullable<string>;

    @IsString()
    @IsOptional()
    travel!: Nullable<string>;

    @IsDateString()
    @IsOptional()
    start_date!: Nullable<string>;

    @IsDateString()
    @IsOptional()
    end_date!: Nullable<string>;

    @IsEnum(DietTypeEnumDto)
    @IsOptional()
    diet_type!: Nullable<DietTypeEnumDto>;

    @IsNumber()
    @IsOptional()
    days_accommodation!: Nullable<number>;

    @IsString()
    @IsOptional()
    daily_expense_accommodation!: Nullable<string>;

    @IsString()
    @IsOptional()
    total_expense_accommodation!: Nullable<string>;

    @IsNumber()
    @IsOptional()
    days_meals!: Nullable<number>;

    @IsString()
    @IsOptional()
    daily_expense_meals!: Nullable<string>;

    @IsString()
    @IsOptional()
    total_expense_meals!: Nullable<string>;

    // Campos legacy (mantener por compatibilidad)
    @IsString()
    @IsOptional()
    expense_person_day!: Nullable<string>;

    @IsString()
    @IsOptional()
    total_expense!: Nullable<string>;

    @IsString()
    @IsNotEmpty()
    amount_allocated_to_project!: string;

    @IsString()
    @IsOptional()
    project_allocation_percentage!: Nullable<string>;

    @IsDateString()
    @IsOptional()
    payment_date!: Nullable<string>;

    @IsEnum(CCAAEnumDto)
    @IsOptional()
    territory!: Nullable<CCAAEnumDto>;

    @IsBoolean()
    @IsOptional()
    is_indirect_cost?: boolean;

    @IsNumber()
    @IsOptional()
    project_expense!: Nullable<number>;

    @IsArray()
    @IsOptional()
    @Type(() => ProjectExpenseInvoiceLineDto)
    lines!: Nullable<ProjectExpenseInvoiceLineDto[]>;

    @IsArray()
    @IsOptional()
    @Type(() => ProjectExpensePaymentInstallmentDto)
    payment_installments!: Nullable<ProjectExpensePaymentInstallmentDto[]>;
}
